import { service } from "../utils/request";

// 获取优惠券设置
export function getfulldetali(data) {
  return service({
    url: "fullpackagepost/agent.index/detail",
    method: "post",
    data: data
  });
}

// 设置优惠券设置
export function setfulldetali(data) {
  return service({
    url: "fullpackagepost/agent.index/edit",
    method: "post",
    data: data
  });
}